/**
 * @file 循环函数实现
 */
import { parseParam, replaceDynamicParameter } from '../index';
import { DYNAMIC_PARAMETER_TYPE } from '../constant';
/**
 * for循环执行函数
 * @param func
 * @param customParamsList
 * @param customFunctionParams
 * @param instanceId
 */
export const forLoop = async (func, customParamsList, customFunctionParams, instanceId) => {
  if (_size(_get(func, 'inParams')) === 2) {
    let loopCount = await parseParam(_get(func, 'inParams')[0], customParamsList, customFunctionParams, instanceId);
    for (let i = 0; i < loopCount; i++) {
      let customParamsListCopy = _cloneDeep(customParamsList);
      replaceDynamicParameter(customParamsListCopy, DYNAMIC_PARAMETER_TYPE.CURRENT_INDEX, i);
      await parseParam(_get(func, 'inParams')[1], customParamsListCopy, customFunctionParams, instanceId, false);
    }
  }
}